import { getMaintenanceMode } from '@srca-b2b/kp5-ui-common/utils/generalAPIs'
import { getSessionDetails } from '@srca-b2b/kp5-ui-common/utils/auth'
import getConfig from 'next/config'
import PropTypes from 'prop-types'
import { useEffect } from 'react'

const { publicRuntimeConfig } = getConfig()

const SaSignIn = (props) => {
  const { postLoginRedirectUrl, userSelectedLang } = props

  useEffect(() => {
    window.location.href = `${publicRuntimeConfig.uspUABaseUrl}?redirectUrl=${encodeURIComponent(
      postLoginRedirectUrl
    )}&loginType=SA&createSession=true&locale=${encodeURIComponent(userSelectedLang)}`
  }, [])
  return null
}

export const getServerSideProps = async (context) => {
  const { req, query, defaultLocale, locale } = context
  // Redirect to maintenance page if maintenanceMode
  const userSelectedLang = query.userSelectedLang || query.locale || locale || defaultLocale
  const maintenanceResponse = await getMaintenanceMode(req.headers.cookie)
  if (maintenanceResponse.statusCode == 200 && maintenanceResponse.data) {
    return {
      redirect: {
        destination: '/en/maintenance',
        permanent: false
      }
    }
  }
  // auth-consume
  const currentBaseUrl = `https://${req.headers.host}`
  const postLoginRedirectUrl = `${currentBaseUrl}/${userSelectedLang}/auth-consume`

  const { isValidAmsSession = false } = getSessionDetails(context)

  if (isValidAmsSession) {
    return {
      redirect: {
        destination: postLoginRedirectUrl,
        permanent: false
      }
    }
  }

  return {
    props: {
      postLoginRedirectUrl,
      userSelectedLang
    }
  }
}

SaSignIn.propTypes = {
  postLoginRedirectUrl: PropTypes.string,
  userSelectedLang: PropTypes.string
}

export default SaSignIn
